export default __webpack_public_path__ + "static/media/3.43775b2f.jpg";